export const getCookieProperties = (host) => {
    if (host.includes('haven.com')) {
        return { domain: '.haven.com', secure: true };
    }
    if (host.includes('haven-dev.com')) {
        return { domain: '.haven-dev.com', secure: true };
    }
    return {};
};
